// @flow
import React, { PureComponent } from "react"
import { connect } from "react-redux"
import classnames from "classnames"
import StarFull from "@kiwicom/orbit-components/lib/icons/StarFull"
import styled, { css } from "styled-components"
import mq from "@kiwicom/orbit-components/lib/utils/mediaQuery"

import { setSeenValues as _setSeenValues } from "common/services/starred/starredDuck"
import cuckoo from "common/services/cuckoo/cuckoo"
import { starredSelector } from "common/services/starred/starredSelectors"
import type { StarredStore } from "common/records/Starred.types"
import { handleBlockScrollBody } from "common/utils/scrollUtils"
import Translate from "../../../../components/Translate"
import NavbarStarredPopup from "./NavbarStarredPopup"
import getPopupItems from "./services/getPopupItems"
import { cuckooEvents } from "common/consts/enums"
import { pageNameSelector } from "common/services/url/navBarLogoUrlSelector"
import { isMobileSelector } from "common/services/window"

const STARRED_BADGE_MAX = 9

const Star = styled(StarFull)`
  ${mq.tablet(css`
    display: none;
  `)};
`

const StarredWrap = styled.div`
  display: none;
  ${mq.tablet(css`
    display: block;
  `)};
`

type Props = {
  starredStore: StarredStore,
  setSeenValues: typeof _setSeenValues,
  isMobile: boolean,
  inverted: boolean,
  page: string,
}

type State = {
  opened: boolean,
}

class NavbarStarred extends PureComponent<Props, State> {
  static defaultProps = {
    inverted: false,
  }

  state = {
    opened: false,
  }

  handleTogglePopup = (e: SyntheticEvent<*>) => {
    e.stopPropagation()
    const { page } = this.props
    cuckoo.track(cuckooEvents.STAR_NAVBAR_CLICK, { page, open: this.state.opened })
    this.setState({ opened: !this.state.opened }, this.amend)
  }

  handleClosePopup = () => {
    this.setState({ opened: false }, this.amend)
  }

  amend = () => {
    if (this.state.opened) {
      cuckoo.infinario("starFlight", { action: "viewStarred" })
    } else {
      const { setSeenValues, starredStore } = this.props

      setSeenValues(getPopupItems(starredStore.items).map(i => i.id))
    }
  }

  render() {
    const { opened } = this.state
    const { starredStore, isMobile, inverted } = this.props

    const starredSize = starredStore.items.length

    if (opened) {
      handleBlockScrollBody(isMobile)
    }

    return (
      <div
        className={classnames("NavbarStarred Navbar-item", {
          _opened: opened,
          _inverted: inverted,
        })}
      >
        <div className="NavbarStarred-item" onClick={this.handleTogglePopup}>
          <StarredWrap>
            <Translate tKey="starred.starred" className="Navbar-item-label hide-small" dynamic />
          </StarredWrap>
          <Star className="Navbar-item-label _icon" size="medium" />
          {starredSize > 0 && (
            <span className="NavbarStarred-item-badge">
              {starredSize > STARRED_BADGE_MAX ? `${STARRED_BADGE_MAX}+` : starredSize}
            </span>
          )}
        </div>
        {opened && <NavbarStarredPopup onClose={this.handleClosePopup} isMobile={isMobile} />}
      </div>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    isMobile: isMobileSelector(state),
    starredStore: starredSelector(state),
    page: pageNameSelector(state),
  }),
  { setSeenValues: _setSeenValues },
)(NavbarStarred)
